export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9871.185fc604.jpg";